import(/* webpackMode: "eager" */ "/src/src/app/[locale]/page.tsx");
